// extracted by mini-css-extract-plugin
export const padding = "homepage-module--padding--AMSS8";
export const videoContainer = "homepage-module--video-container--2BUzx";
export const sliderVideo = "homepage-module--slider-video--3SU3J";
export const videoTextContainer = "homepage-module--video-text-container--3X7wf";
export const galleryImage = "homepage-module--gallery-image--e86Sj";